module.exports = __webpack_public_path__ + "img/play.70ace1bb.png";